import React from 'react';
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import {getStoredData} from "../../JsonFiles/fetchData";

const AddServicesPage = () => {
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminServices : {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/services'; // API endpoint for creating product
  const successRedirect = '/admin/services'; // Redirect after successful product creation

  return (
    <div>
      <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
    </div>
  );
};


export default AddServicesPage;
